// extracted by mini-css-extract-plugin
export default {"iconStyles":"styles_iconStyles__XSegw","imgStyles":"styles_imgStyles__zJGzo","bone-skeleton":"styles_bone-skeleton__e1n4u"};